module.exports = __webpack_public_path__ + "media/components/country-flag/static/td-a8421676d2aa5259e8f4a122d4f8650c.svg";